import ReactVisibilitySensor from "react-visibility-sensor"
import Footer from "../../../layouts/Footer"
import TitleBorderLeft from "../../../components/Text/TitleBorderLeft"
import BorderLeftBox from "../../../components/boxes/BorderLeftBox"
import MainHeader from "../../../layouts/MainHeader"
import embeddingPageData from "../../../data/arabic/subpages/embedding-page-data-ar"

const EmbeddingPageAr = () => {
  return (
    <main className="page" id="main">
    <div className="sticky-view-two">
    <div className='sticky-container'>
        <MainHeader
            image={{
                src : require(`../../../assets/images/wallpaper/${embeddingPageData.headerImage.name}`),
                alt : embeddingPageData.headerImage.alt,
            }}
            title=""
        />
    </div>
    <div className="sticky-container-two">
        <div className="wrapper-small">
            <h1 className="title-center">{embeddingPageData.mainTitle}</h1>
            <BorderLeftBox 
                title={embeddingPageData.boxOne.title}
                subtitle={embeddingPageData.boxOne.subtitle}
            />
            <BorderLeftBox 
                title={embeddingPageData.boxTwo.title}
                subtitle={embeddingPageData.boxTwo.subtitle}
            />
            <p className="text-paragraph">{embeddingPageData.paragraphOne}</p>
            <p className="text-paragraph">{embeddingPageData.paragraphThree}</p>
            <div className="space-50"></div>
            <div className="space-50"></div>
            <TitleBorderLeft>{embeddingPageData.borderTitle}</TitleBorderLeft>
            <div className="space-50"></div>
            <div className="space-50"></div>
            <ReactVisibilitySensor
                partialVisibility
            >
            {({isVisible} : any) => (
                <img 
                    src={require(`../../../assets/images/plans/${embeddingPageData.graphPlan.name}`)}
                    alt={embeddingPageData.graphPlan.alt}
                    className={`embedding-graph-image an-move-top-fade-in ${isVisible ? "an-active" : ""}`}
                />
            )}
            </ReactVisibilitySensor>
            <div className="space-50"></div>
            <div className="space-50"></div>
            <div className="space-50"></div>
        </div>
        <Footer withBlogs={false} />
    </div>
    </div>
    </main>
  )
}

export default EmbeddingPageAr